

import {  useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';


import apiService from "../api/ApiService";
import { useForm } from "react-hook-form";
import { Close, Key, Person, Repeat, Title } from "@mui/icons-material";


const AddUser=()=>{
    const {currentAdmin}=useSelector(state=>state.p.admin);
    
    const {closeD,opens}=useGlobalContext();
    const {
          register,
          handleSubmit,
          formState: { errors }
        } = useForm();
        
     
    const AddNewSensor=async(data)=>{
            const {title,password,username,password2,phoneNumber}=data
            if(password===password2){
                const data1=JSON.stringify({phoneNumber,title,password,username,farmId:currentAdmin.id})
            const res=await apiService.createUSer(data1);
            window.location.reload()
            }else{
                toast.error('مقادیر رمز عبور و تکرار آن برابر نیست')
            }
    }
 
    

    return <div onClick={closeD} className={`modal-overlay ${opens&&'show-modal'} `}>
        <form onSubmit={handleSubmit(AddNewSensor)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <AddToPhotosIcon fontSize="large"/>

            <h4 > ایجاد کاربر جدید</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("title", {
              required: 'این مقدار ضروری است'
            })}/>
            <label for="" className={'labelSS'}><Title fontSize="small"/> موضوع </label>
            {errors?.title?.message&&<span className='errMsg'>{errors?.title?.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input   autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("username", {
              required: 'این مقدار ضروری است',pattern:{
                value:/^[A-Za-z0-9]+$/,
                message:'فقط حروف لاتین'
              }
            })}/>
            <label for="" className={'labelSS'} ><Person fontSize="small"/> نام حساب کاربری </label>
            {errors?.username?.message&&<span className='errMsg'>{errors?.username?.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input   autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("phoneNumber", {
              required: 'این مقدار ضروری است',pattern:{
                value:/^09\d{9}$/,
                message:'شماره معتبر نیست'
              }
            })}/>
            <label for="" className={'labelSS'} ><Person fontSize="small"/>  شماره همراه </label>
            {errors?.phoneNumber?.message&&<span className='errMsg'>{errors?.phoneNumber?.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="password"  className='inputSS' placeholder="a" {...register("password", {
              required: 'این مقدار ضروری است',pattern: {
                value: /^(?=.*[A-Za-z0-9])[A-Za-z0-9@#$%=\/?<>:;^&*()_+!~-]+$/,
                message: 'فقط حروف لاتین و کاراکترهای ویژه'
              }
            })}/>
            <label for="" className={'labelSS'}><Key fontSize="small"/> رمز عبور </label>
            {errors?.password?.message&&<span className='errMsg'>{errors?.password?.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="password"  className='inputSS' placeholder="a" {...register("password2", {
              required: 'این مقدار ضروری است',pattern: {
                value: /^(?=.*[A-Za-z0-9])[A-Za-z0-9@#$%=\/?<>:;^&*()_+!~-]+$/,
                message: 'فقط حروف لاتین و کاراکترهای ویژه'
              }
            })}/>
            <label for="" className={'labelSS'}><Repeat fontSize="small"/>  تکرار رمز عبور </label>
            {errors?.password2?.message&&<span className='errMsg'>{errors?.password2?.message}</span>}
        </div>
        
        
        
        <button className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default  AddUser